/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LeadDispositionsResponseApiModel } from '../../models/lead-dispositions-response-api-model';

export interface GetLeadDispositions$Params {
}

export function getLeadDispositions(http: HttpClient, rootUrl: string, params?: GetLeadDispositions$Params, context?: HttpContext): Observable<StrictHttpResponse<LeadDispositionsResponseApiModel>> {
  const rb = new RequestBuilder(rootUrl, getLeadDispositions.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LeadDispositionsResponseApiModel>;
    })
  );
}

getLeadDispositions.PATH = '/leads/dispositions';
